import { Component, OnInit } from '@angular/core';
import { ShopService } from 'src/app/services/shop.service';
import { Page } from 'src/app/models/page.model';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  pages$: any;
  page: Page = null;

  constructor(
    private shop: ShopService
  ) { }

  ngOnInit() {
    this.pages$ = this.shop.pages.subscribe(
      (pages) => {
        pages.forEach(c => {
          if (c.slug === 'galerie') {
            this.page = c;
          }
        });
      }
    );
  }

}
